import { Component, inject, Injector, OnInit } from '@angular/core';
import { IIKOTableGridModule } from '../../lib/iiko-table-grid.module';
import {
  CellClickedEventDataInterface,
  ColumnResizedEventDataInterface,
  HeaderClickedEventDataInterface,
  RowMovedEventDataInterface,
  RowSelectionChangedEventDataInterface,
  TableGridRowDataType
} from '../../lib';
import { CellComponent, ColumnDefinition, TabulatorFull } from 'tabulator-tables';
import { LicenseService } from '../../services/license.service';
import { LicenseInterface } from '../../interfaces/license.interface';
import { CustomToggleComponent } from './custom-toggle/custom-toggle.component';
import { createCustomElement, NgElement, NgElementConstructor, WithProperties } from '@angular/elements';
import { CustomToggleModule } from './custom-toggle/custom-toggle.module';
import { MatSnackBar } from '@angular/material/snack-bar';
import moment from 'moment';
import { CustomTooltipComponent } from './custom-tooltip/custom-tooltip.component';
import { CustomTooltipModule } from './custom-tooltip/custom-tooltip.module';
import { MatDialog } from '@angular/material/dialog';
import { ShowEnvironmentComponent } from './show-environment/show-environment.component';
import { MatInputModule } from '@angular/material/input';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CustomEditModule } from './custom-edit/custom-edit.module';
import { CustomEditComponent } from './custom-edit/custom-edit.component';
import { DinamicLoaderService } from '../../services/dinamic-loader.service';
import { SidenavService } from '../../services/sidenav.service';
import { EditModulesComponent } from './edit-modules/edit-modules.component';

@Component({
  selector: 'app-license-info',
  standalone: true,
  imports: [
    IIKOTableGridModule,
    CustomToggleModule,
    CustomTooltipModule,
    CustomEditModule,
    MatInputModule,
    ReactiveFormsModule
  ],
  templateUrl: './license-info.component.html',
  styleUrl: './license-info.component.scss'
})
export class LicenseInfoComponent implements OnInit {
  licenseService = inject(LicenseService);
  snackbarService: MatSnackBar = inject(MatSnackBar);
  dialog: MatDialog = inject(MatDialog);
  dinamicLoaderService: DinamicLoaderService = inject(DinamicLoaderService);
  sidenavService: SidenavService = inject(SidenavService);

  table: TabulatorFull | any;

  columnDefs: ColumnDefinition[] = [
    {
      title: '',
      field: 'edit',
      width: 50,
      headerSort: false,
      hozAlign: 'center',
      formatter: (cell: CellComponent) => {
        return this.customEditFormatter(cell);
      },
    },
    {
      title: 'id',
      field: 'id',
      width: 80,
      headerSort: true,
    },
    {
      title: 'Organization',
      field: 'environment',
      width: 150,
      headerSort: true,
      formatter: (cell: CellComponent) => {
        const value = cell.getValue();
        return value.Title
      },
    },
    {
      title: 'environment',
      field: 'environment',
      width: 100,
      headerSort: true,
      formatter: (cell: CellComponent) => {
        return this.customTooltipFormatter(cell);
      },
    },

    {
      title: 'user',
      field: 'user',
      width: 100,
      headerSort: true,
      formatter: (cell) => {
        const val = cell.getValue();
        if (val) {
          const user_fio = val.user_fio
          const email = val.email
          return `${user_fio} (${email})`
        }
        return ''

      }
    },
    {
      title: 'user_info',
      field: 'user_info',
      width: 100,
      headerSort: true,
    },
    {
      title: 'license_status',
      field: 'license_status',
      width: 150,
      headerSort: true,
      formatter: (cell: CellComponent) => {
        return this.customToggleFormatter(cell);
      },
    },
    {
      title: 'license_key',
      field: 'license_key',
      width: 250,
      headerSort: true,
      formatter: (cell: CellComponent) => {
        return this.customTooltipFormatter(cell);
      },
    },
    {
      title: 'Available registration',
      field: 'uuid',
      width: 250,
      headerSort: true,
      formatter: (cell: CellComponent) => {
        return this.customToggleFormatterUuid(cell);
      },
    },

    {
      title: 'module_list',
      field: 'module_list',
      width: 250,
      headerSort: true,
      formatter: (cell: CellComponent) => {
        return this.customTooltipFormatter(cell);
      },
    },
    {
      title: 'client_os',
      field: 'client_os',
      width: 120,
      headerSort: true,
    },
    {
      title: 'date_expired',
      field: 'date_expired',
      width: 150,
      headerSort: true,
      formatter: (cell) => {
        if (cell.getValue()) {
          return moment(cell.getValue()).format('DD.MM.YYYY')
        }
        return '';

      }
    },
    {
      title: 'date_create',
      field: 'date_create',
      width: 150,
      headerSort: true,
      formatter: (cell) => {
        return moment(cell.getValue()).format('DD.MM.YYYY')
      }
    },
    {
      title: 'date_update',
      field: 'date_update',
      width: 150,
      headerSort: true,
      formatter: (cell) => {
        return moment(cell.getValue()).format('DD.MM.YYYY')
      }
    },


  ];

  tableData: TableGridRowDataType[] | any = [];

  searchStringCtrl = new FormControl<string>('', {nonNullable: true});
  searchStringInTable = '';

  constructor(private injector: Injector) {
    this.defineCustomButtons();
    this.defineCustomTooltip();
    this.defineCustomEdit();

    this.searchStringCtrl.valueChanges
      .pipe(takeUntilDestroyed())
      .subscribe((value: string) => {
        this.searchStringInTable = value
        this.table.setFilter(this.customFilter, {value});
        this.table.redraw(true);
      });
  }

  customFilter(data: any, filterParams: any) {
    return JSON.stringify(data).toLowerCase().includes(filterParams.value.toLowerCase())
  }

  ngOnInit() {
   this.init();
  }

  init(){
    this.licenseService.getLicenseList()
      .subscribe((data: LicenseInterface[]) => {
        console.log('data', data)
        this.tableData = data.map((item) => {
          // item.environment = JSON.stringify(item.environment)
          return item
        });
      })
  }

  defineCustomButtons() {
    if (!customElements.get('app-custom-toggle')) {
      const myElement = createCustomElement(CustomToggleComponent, {
        injector: this.injector,
      }) as NgElementConstructor<unknown>;
      customElements.define('app-custom-toggle', myElement);
    }
  }


  defineCustomTooltip() {
    if (!customElements.get('app-custom-tooltip')) {
      const myElement = createCustomElement(CustomTooltipComponent, {
        injector: this.injector,
      }) as NgElementConstructor<unknown>;
      customElements.define(`app-custom-tooltip`, myElement);
    }
  }

  defineCustomEdit() {
    if (!customElements.get('app-custom-edit')) {
      const myElement = createCustomElement(CustomEditComponent, {
        injector: this.injector,
      }) as NgElementConstructor<unknown>;
      customElements.define('app-custom-edit', myElement);
    }
  }


  private customTooltipFormatter(cell: CellComponent): string | HTMLElement {
    cell.getElement().classList.add('py6');
    const myElement =
      document.createElement('app-custom-tooltip') as NgElement &
        WithProperties<CustomTooltipComponent>;
    const value = cell.getValue();
    const data = cell.getData() as Record<string, string>;
    // myElement.btnCaption = value;
    myElement.myTooltip = 'Click to view';
    // myElement.myTooltip = 'Active/Disable';
    myElement.addEventListener('clickMyButton', clickRes => {
      const dialogRef = this.dialog.open(ShowEnvironmentComponent, {
        data: value,
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });

    });

    return myElement;
  }

  private customToggleFormatterUuid(cell: CellComponent): string | HTMLElement {
    cell.getElement().classList.add('py6');
    const myElement =
      document.createElement('app-custom-toggle') as NgElement &
        WithProperties<CustomToggleComponent>;
    const value = cell.getValue();
    const data: any = cell.getData();
    const status = (value?.length === 0 || value === null) && data?.license_status === 'disabled'
    myElement.btnCaption = status ? 'enabled' : 'disabled';
    myElement.customValue = status;

    myElement.addEventListener('clickMyButton', clickRes => {
      const license: LicenseInterface = cell.getRow().getData() as LicenseInterface;
      if (!status) {
        license.uuid = '';
        license.license_status = 'disabled';
      } else {
        license.uuid = '';
        license.license_status = 'active';
      }

      this.licenseService.updateLicense(license)
        .subscribe((res) => {
          this.snackbarService.open(`Success ${res.license_status} !`, 'close', {duration: 3000})
          this.init();
        })


    });

    return myElement;
  }

  private customToggleFormatter(cell: CellComponent): string | HTMLElement {
    cell.getElement().classList.add('py6');
    const myElement =
      document.createElement('app-custom-toggle') as NgElement &
        WithProperties<CustomToggleComponent>;
    const value = cell.getValue();
    const data = cell.getData() as Record<string, string>;
    // myElement.btnCaption = 'Включить';
    myElement.btnCaption = value;
    myElement.customValue = value !== 'disabled';
    // myElement.myTooltip = data.tooltip;
    // myElement.myTooltip = 'Active/Disable';
    myElement.addEventListener('clickMyButton', clickRes => {
      if (value === 'disabled') {
        const res = confirm('Are you sure you want to enable ?');
        if (res) {
          cell.setValue('active');
        }

      }
      if (value === 'active') {
        const res = confirm('Are you sure you want to disable ?');
        if (res) {
          cell.setValue('disabled')
        }
      }

      const license: LicenseInterface = cell.getRow().getData() as LicenseInterface;
      console.log('license', license)
      this.licenseService.updateLicense(license)
        .subscribe((res) => {
          this.snackbarService.open(`Success ${res.license_status} !`, 'close', {duration: 3000});
          this.init();
        })


    });

    return myElement;
  }

  private customEditFormatter(cell: CellComponent): string | HTMLElement {
    cell.getElement().classList.add('py6');
    const myElement =
      document.createElement('app-custom-edit') as NgElement &
        WithProperties<CustomEditComponent>;

    myElement.addEventListener('clickMyButton', () => {
      const license: LicenseInterface = cell.getRow().getData() as LicenseInterface;
      this.dinamicLoaderService.loadComponent$.next({
        component: EditModulesComponent,
        data: { license, that: this }
      });
      setTimeout(() => {
        this.sidenavService.sideNavState$.next(true);
      });
    });

    return myElement;
  }

  groupHeaderCallback(): string {
    return 'test';
  }

  onCellClicked($event: CellClickedEventDataInterface) {
    console.log('cell clicked', $event);
  }

  onColumnResized($event: ColumnResizedEventDataInterface) {
    console.log('column resized', $event);
  }

  onHeaderClicked($event: HeaderClickedEventDataInterface) {
    console.log('header clicked', $event);
  }

  onRowSelectionChanged($event: RowSelectionChangedEventDataInterface) {
    console.log('row selection changed', $event);
  }

  onRowMoved($event: RowMovedEventDataInterface) {
    console.log('row moved', $event);
  }

  tableInstanceChange($event: any) {
    this.table = $event;
  }
}
